<template>
  <div>
    <vsmallheader></vsmallheader>

    <div :style="'background-image:url(' + bannerheadUrl + ')'" class="persbox">
      <div class="personMessage">
        <div class="messageLeft">
          <img :src="userPhoto" alt />
          <div class="messageflex">
            <button @click="studyset">学习设置</button>
            <button @click="passSet">信息维护</button>
          </div>
        </div>

        <div class="messageCenter">
          <template v-for="(item,index) in photoList">
          <div
            :key="index"
            @click="photoArea(index,item)"
            :class="{heightlight : photoindex==index}"
            v-if="!([2,3].includes(index) && isTeach == false)"
          >
            <router-link :to="item.path" class="a" v-if="index!=2 && index !=3">
              <div class="messageimg">
                <el-badge :value="totalmsg" class="item" v-if="index==0">
                  <img :src="item.img" style="width:60px;height:60px" />
                </el-badge>
                <img :src="item.img" v-else style="width:60px;height:60px" />
              </div>
              <div style="padding: 10px 0;font-weight:700;color:#fff;font-size:16px">{{item.name}}</div>
            </router-link>
            <router-link :to="item.path" class="a" v-else-if="index==2 && isTeach">
              <div class="messageimg">
                <el-badge :value="totalmsg" class="item" v-if="index==0">
                  <img :src="item.img" style="width:60px;height:60px" />
                </el-badge>
                <img :src="item.img" v-else style="width:60px;height:60px" />
              </div>
              <div style="padding: 10px 0;font-weight:700;color:#fff;font-size:16px">{{item.name}}</div>
            </router-link>
            <router-link :to="item.path" class="a" v-else-if="index==3 && isTeach">
              <div class="messageimg">
                <img :src="item.img" style="width:60px;height:60px" />
              </div>
              <div style="padding: 10px 0;font-weight:700;color:#fff;font-size:16px">{{item.name}}</div>
            </router-link>
          </div>
          </template>
        </div>

        <div class="messageRight">
<!--	        <router-link to="/personCenter/UserVisualization" class="a">-->
	        <div @click="showVisual = true">
		        <div class="messageimg">
			        <img src="@/assets/newIndex/icon24.png" style="width:60px;height:60px"/>
		        </div>
		        <div style="padding: 10px 0;font-weight:700;color:#fff;font-size:16px">健康数据分析</div>
	        </div>
<!--	        </router-link>-->
        </div>
      </div>
    </div>

    <div class="persondata">
      <div class="persondataleft">
        <div style="width:150px">
          <el-menu
            :default-active="defaultActive"
            class="el-menu-vertical-demo"
            @open="handleOpen"
            @close="handleClose"
          >
            <router-link :to="item.path" v-for="(item,index) in labletable" :key="index">
              <el-menu-item
                @click="personcenterhome(index)"
                :index="index.toString()"
                style="font-size:16px"
              >
                <i :class="item.icon"></i>
                <span>{{item.name}}</span>
              </el-menu-item>
            </router-link>
          </el-menu>
        </div>
      </div>

      <div class="persondataright">
        <router-view></router-view>
      </div>
      <!-- <div class="persondataright" v-else>
        <router-view></router-view>
      </div>-->
    </div>

    <el-dialog
      title="学习设置"
      :visible.sync="dialogVisibleStudy"
      width="60%"
      v-el-drag-dialog
      class="dialog-mini"
    >
      <div class="studynav">
        <div>请选择你的学习兴趣标签</div>
        <div>根据你已标记的学习标签将为你推荐以下你可能会感兴趣的内容</div>
      </div>
      <div>
        <div class="zymsg">
          <div class="zymsgtitle">资源标签：</div>
          <el-checkbox-group v-model="documentIdx" style="flex:1">
            <el-checkbox
              v-for="(item) in studycheckzy"
              :label="item.id"
              border
              :key="item.id"
              style="margin-bottom: 10px;"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="zymsg">
          <div class="zymsgtitle">考试标签：</div>
          <el-checkbox-group v-model="exmaIdx" style="flex:1">
            <el-checkbox
              v-for="(item) in studycheck"
              :label="item.id"
              border
              :key="item.id"
              style="margin-bottom: 10px;"
            >{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleStudy = false">取 消</el-button>
        <el-button type="primary" @click="confirmSumt">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="信息维护"
      :visible.sync="dialogVisiblepass"
      width="65%"
      top="5vh"
      class="dialog-mini"
      v-if="dialogVisiblepass "
    >

      <el-form
        :rules="rules"
        ref="userIdData"
        :model="userIdData"
        label-position="right"
        label-width="120px"
      >
        <el-row>
          <el-col :span="7">
            <el-form-item
              size="small"
              prop="name"
              v-if="Object.keys(userIdData).indexOf('name')>=0"
            >
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 名</label>
              <el-input v-model="userIdData.name"></el-input>
            </el-form-item>

            <el-form-item prop="sex" size="small">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 别</label>
              <el-radio-group v-model="userIdData.sex">
                <el-radio :label="true">男</el-radio>
                <el-radio :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item size="small" prop="ethic">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >民&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 族</label>
              <el-input v-model="userIdData.ethic"></el-input>
            </el-form-item>

            <el-form-item size="small" :label="'身份证号'" prop="idCard">
              <el-input v-model="userIdData.idCard" disabled></el-input>
            </el-form-item>
            <el-form-item size="small" :label="'出生日期'" prop="birthday">
              <el-input v-model="userIdData.birthday" disabled></el-input>
              <!-- <el-date-picker
                style="width:100%"
                v-model="userIdData.birthday"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>-->
            </el-form-item>

            <el-form-item size="small" prop="code">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >警&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 号</label>
              <el-input v-model="userIdData.code"></el-input>
            </el-form-item>

            <el-form-item size="small" :label="'政治面貌'" prop="party">
              <el-input v-model="userIdData.party"></el-input>
            </el-form-item>

            <el-form-item size="small" :label="'所在部门'" prop="deptId">
<!--                :parentIdOne="parentIdOne"-->
                <TreeSelect
                    v-if="isDept"
                    style="margin-bottom: 10px"
                    :checked-keys="[{label: userIdData.deptName}]"
                    :placeholderOne="'部门'"
                    :width="150"
                    @popoverHide="AddDept"
                    @clearDept="clearDept"
                ></TreeSelect>
                <el-input v-else v-model="userIdData.deptName" disabled></el-input>
            </el-form-item>

            <el-form-item size="small" required prop="jzDicId">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >警&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 种</label>
              <eleSelect
                style="width:231px"
                :width="231"
                :NamespaceId="1"
                :key="sid"
                @selectData="AddjzDic"
                :typeids="userIdData.jzDicId "
                v-if="dialogVisiblepass"
              ></eleSelect>
            </el-form-item>
            <el-form-item size="small" :label="'公安工作日期'" prop="joinDate">
              <el-date-picker
                style="width:100%"
                v-model="userIdData.joinDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>

            <el-form-item size="small" prop="phone" :label="'联系电话'">
              <el-input v-model="userIdData.phone"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="11">
            <el-form-item size="small" :label="'登录密码'" prop="passWord">
              <el-input v-model="userIdData.passWord" show-password></el-input>
            </el-form-item>

            <el-form-item size="small" :label="'人员状态'">
              <eleSelect
                :isdisabled="true"
                style="width:432px"
                :width="432"
                :NamespaceId="63"
                :key="sid"
                :typeids="userIdData.status"
                v-if="dialogVisiblepass"
              ></eleSelect>
            </el-form-item>

            <el-form-item size="small" :label="'毕业院校'" prop="school">
              <el-input v-model="userIdData.school"></el-input>
            </el-form-item>

            <el-form-item size="small" :label="'所学专业'" prop="major">
              <el-input v-model="userIdData.major"></el-input>
            </el-form-item>

            <el-form-item size="small" prop="duty">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >学&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 历</label>
              <el-input v-model="userIdData.duty"></el-input>
            </el-form-item>

            <el-form-item size="small" :label="'工作单位'" prop="unit">
              <el-input v-model="userIdData.unit"></el-input>
            </el-form-item>

            <el-form-item size="small" prop="zwjb">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 级</label>
              <el-input v-model="userIdData.zwjb"></el-input>
            </el-form-item>

            <el-form-item size="small" prop="zwmc">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >职&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 务</label>
              <el-input v-model="userIdData.zwmc"></el-input>
            </el-form-item>
            <el-form-item size="small" prop="ranks">
              <label
                slot="label"
                style="color: #606266 !important;font-weight:400 !important"
              >警&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 衔</label>
              <!-- <el-input v-model="userIdData.ranks"></el-input> -->

              <eleSelect
                style="width:432px"
                :width="432"
                :NamespaceId="70"
                :key="sid"
                @selectData="Addrankid"
                :typeids="userIdData.rankId"
                v-if="dialogVisiblepass"
              ></eleSelect>
            </el-form-item>

            <!-- <el-form-item size="small" :label="'人员标签'" prop="labelName"> -->
            <!-- <el-input v-model="userIdData.labelName" disabled></el-input> -->
            <!-- </el-form-item> -->

            <el-form-item size="small" :label="'人员标签'">
              <el-select
                style="width:100%"
                v-model="labelIdList"
                multiple
                placeholder="请选择"
                @change="btnbaseType"
              >
                <el-option
                  v-for="item in optionsType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item size="small" :label="'上传头像'" prop="photo">
              <!-- <changerHeader @chilUpload="chilUpload" :imageUrl="userIdData.photo"></changerHeader> -->

              <changerheader
                @chilUpload="chilUpload"
                style="margin-left:10px"
                :imageUrl="userIdData.photo?userIdData.photo:''"
              ></changerheader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item size="small" :label="'个人简介'">
              <el-input type="textarea" v-model="userIdData.introduce" :rows="4"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblepass = false">取消</el-button>
        <el-button type="primary" @click="UploadUser">确 定</el-button>
      </span>
    </el-dialog>
  <user-visualization v-if="showVisual" @close="showVisual = false"></user-visualization>
  </div>
</template>
<script>
import * as perapi from '@/api/personcenter/index';
import vsmallheader from '@/views/smallHeader/index';
import personhome from './component/personhome.vue';
import changerheader from '@/components/changeHeader';
import { getInfo, setInfo, removeInfo } from '@/utils/auth';
import elDragDialog from '@/directive/el-dragDialog';
import eleSelect from '@/components/elSelect';
import TreeSelect from "@/components/treeSelectt/index.vue";
import {GetDeptPower} from "@/api/personcenter/index"; //下拉框
import userVisualization from "@/views/personCenter/component/UserVisualization.vue";

export default {
  directives: {
    elDragDialog,
  },
  components: {
      TreeSelect,
    vsmallheader,
    personhome,
    changerheader,
    eleSelect,
	  userVisualization
  },
  data() {

    //身份证号码正则
    const checkIDCard = (rule, value, callback) => {
      const IDCardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value) {
        if (IDCardReg.test(value)) {
          callback();
        } else {
          callback(new Error('身份证号格式不正确'));
        }
      } else {
        callback(new Error('请输入身份证号'));
      }
    };

    return {
		showVisual: false,
        isDept: false,
        deptId: JSON.parse(this.$store.state.User.infos).unitId,
        parentIdOne: JSON.parse(this.$store.state.User.infos).unitId,
      sid: +new Date(),
      totalmsg: 0,
      sexn: '男',
      sexv: '女',
      disabledname: true,
      bannerheadUrl: require('@/assets/newIndex/bg02.jpg'),
      defaultActive: '0',
      documentIdx: [],
      exmaIdx: [],
      dialogVisibleStudy: false,
      dialogVisiblepass: false,
      photoindex: -1,
      lableindex: -1,
      // isTeach: JSON.parse(this.$store.state.User.infos).isTearch,
      // userPhoto: JSON.parse(this.$store.state.User.infos).photo,
  
      photoList: [
        {
          name: '消息',
          img: require('@/assets/newIndex/icon22.png'),
          path: '/personCenter/information',
        },
        // {
        //   name: '任务',
        //   img: require('@/assets/newIndex/icon23.png'),
        //   path: '/personCenter/task',
        // },

        {
          name: '活动',
          img: require('@/assets/newIndex/icon24.png'),
          path: '/personCenter/activity',
        },
        {
          name: '博文管理',
          img: require('@/assets/newIndex/icon28.png'),
          path: '/personCenter/educational',
        },
        {
          name: '教官信息',
          img: require('@/assets/newIndex/icon29.png'),
          path: '/personCenter/teachermsg',
        },
        {
          name: '我的收藏',
          path: '/personCenter/iamcollect',
          img: require('@/assets/newIndex/icon27.png'),
          icon: 'el-icon-folder-opened',
        },
        {
          name: '我的证书',
          path: '/personCenter/iamcertificate',
          img: require('@/assets/newIndex/icon23.png'),
          icon: 'el-icon-picture',
        },
        // {
        //   name: '警衔提升',
        //   img: require('@/assets/newIndex/icon29.png'),
        //   path: '/personCenter/policerank',
        // },
      ],
      labletable: [
        {
          name: '首页',
          path: '/personCenter/personhome',
          icon: 'el-icon-s-home',
        },
        {
          name: '准入学习',
          path: '/personCenter/iamStudy',
          icon: 'el-icon-edit-outline',
        },
        {
          name: '我的调训',
          path: '/personCenter/iamTrain',
          icon: 'el-icon-tickets',
        },
        {
          name: '教官日志',
          path: '/personCenter/iamBstanRtsis',
          icon: 'el-icon-tickets',
        },
        {
          name: '教官课件',
          path: '/personCenter/upLoadResource',
          icon: 'el-icon-upload2',
        },
        {
          name: '班级管理',
          path: '/personCenter/iamClasserLogs',
          icon: 'el-icon-tickets',
        },
        {
          name: '我的考试',
          path: '/personCenter/iamExam',
          icon: 'el-icon-edit',
        },
        {
          name: '我的测评',
          path: '/personCenter/iamVote',
          icon: 'el-icon-document-copy',
        },
        // {
        //   name: '我的考勤',
        //   path: '/personCenter/kqCountBox',
        //   icon: 'el-icon-s-claim',
        // },
        {
          name: '我的训历',
          path: '/personCenter/iamTrainDate',
          icon: 'el-icon-collection-tag',
        },
        {
          name: '免训申请',
          path: '/personCenter/iamApplication',
          icon: 'el-icon-tickets',
        },
        {
          name: '健康测评',
          path: '/personCenter/evaluation',
          icon: 'el-icon-tickets',
        },
        {
          name: '健康数据',
          path: '/personCenter/UserVisualization',
          icon: 'el-icon-tickets',
        },
        {
          name: '心理测评',
          path: '/personCenter/psychologicalTest',
          icon: 'el-icon-document-copy',
        },
        
      ],
      studycheck: [],
      studycheckzy: [],
      userIdData: {},
      rules: {
        name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        ethic: [{ required: true, message: '民族不能为空', trigger: 'blur' }],
        idCard: [{ required: true, validator: checkIDCard, trigger: 'blur' }],
        unit: [{ required: true, message: '工作单位不能为空', trigger: 'blur' }],
        passWord: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { pattern: '', message: '' },
        ],
        jzDicId: [{ required: true, message: '警种不能为空', trigger: 'blur' }],
        phone: [
          { required: true, message: '联系电话不能为空', trigger: 'blur' },
        ],
        deptId: [{ required: true, validator:(rule, value, callback)=>{
          if(!this.userIdData.deptName){
            callback(new Error('所在部门不能为空'))
          }else{
            callback();
          }
        }, trigger: ['change','blur'] }],
      },
      // userdeptName: JSON.parse(this.$store.state.User.infos).deptName,
      // isTearch: Boolean(JSON.parse(this.$store.state.User.infos).isTearch),
      userdeptName:'',
      isTearch:false,
      userPhoto:'',
      isTeach:false,

      LabelList: [],
      temptwo: '',
      jzName: '',
      labelIdList: [],
      optionsType: [],
    };
  },
  computed: {
    getinfo() {
      return this.$store.state.User.infos;
    },
  },
  created() {

    if (this.$store.state.User.infos) {
      //判断是否登录，是的或取值，没登录取值会报错
      let list = JSON.parse(getInfo('infos'));
      this.userdeptName=list.deptName
      this.isTearch=Boolean(list.deptName)
      this.userPhoto=list.photo
      this.isTeach=list.isTearch
    }
    
    // 判断是否是教官是的话就显示教案心得，不是就不显示
    if (this.isTeach == false) {
      this.photoList.splice(6, 1);
      this.labletable = this.labletable.filter(item=>!['/personCenter/upLoadResource'].includes(item.path));
    } else {
      
    }
  },
  mounted() {
    this.getmsgList();
    this.getRouterName(this.$route.path);
    this.getuserdata();
  },
  methods: {
      //部门
      AddDept(checkedIds, checkedData) {
          this.userIdData.deptId = checkedData.id;
          this.userIdData.deptName = checkedData.label;
      },
      clearDept() {
          this.userIdData.deptId = null;
          this.userIdData.deptName = null;
      },
    //警种类别
    AddjzDic(row) {
      this.userIdData.jzDicId = row.value;
    },
    // 警衔 ranks
    Addrankid(row) {
      this.userIdData.ranks = row.label;
      this.userIdData.rankid = row.value;
    },
    getListbaseType() {
      let para = {
        NamespaceId: 74,
      };
      perapi.GetByTypeIdk(para).then((res) => {
        this.optionsType = res.result;
      });
    },
    btnbaseType(val) {
      let codeData = val;
      let codeDataLength = codeData.length;
      let baseTypeNameList = [];
      for (let i = 0; i < codeDataLength; i++) {
        let value = codeData[i];
        this.optionsType.map((item) => {
          if (item.id == value) {
            baseTypeNameList.push(item.name);
          }
        });
      }

      this.temp.labelId = this.labelIdList.join(',');
      this.temp.LabelName = baseTypeNameList.join(',');
    },
    getmsgList() {
      let listQuery = {
        userId: this.$store.state.User.ids,
      };
      perapi.GetMesCountst(listQuery).then((res) => {
        // console.log(res);
        this.totalmsg = res.result;
      });
    },
    getuserdata() {
      let para = {
        id: this.$store.state.User.ids,
      };

      perapi.PmiUserOthergetList(para).then((response) => {
        this.temptwo = Object.assign({}, response.result);
        // console.log(response.result);
      });
    },
    // 确定资源
    confirmSumt() {
      let data = { userId: this.$store.state.User.ids, rule: '' };
      let rulelist = {};
      if (this.documentIdx.length != 0) {
        rulelist.document = this.documentIdx.toString();
      }
      if (this.exmaIdx.length != 0) {
        rulelist.exam = this.exmaIdx.toString();
      } else {
        rulelist.exam = '';
      }
      data.rule = rulelist;

      perapi.UpdateLabel(data).then((res) => {
        // console.log(res);
        this.dialogVisibleStudy = false;
        this.$notify({
          title: '成功',
          message: '上传成功',
          type: 'success',
        });
      });
    },
    // 资源标签
    // 获取资源标签数据
    getPmiPic() {
      let para = {
        Page: 1,
        Limit: 20,
        NamespaceId: 65,
      };
      perapi.getPmiDic(para).then((res) => {
        res.result.forEach((element) => {
          let obj = {
            name: element.name,
            id: element.id,
          };
          this.studycheckzy.push(obj);
        });
      });
    },
    getPmiPickm() {
      let para = {
        NamespaceId: 6,
      };
      perapi.GetByTypeIdk(para).then((res) => {
        res.result.forEach((element) => {
          let obj = {
            name: element.name,
            id: element.id,
          };
          this.studycheck.push(obj);
        });
        // console.log(this.studycheck);
        this.GetLabelfz();
      });
    },
    // 获取标签的赋值GetLabelfz
    GetLabelfz() {
      let para = {
        userId: this.$store.state.User.ids,
      };
      perapi.GetLabelList(para).then((res) => {
        let list = JSON.parse(res.result);
        if (list.exam) {
          let exmaIdx = list.exam.split(',');
          this.exmaIdx = exmaIdx.map(Number);
        }
        if (list.document) {
          let documentIdx = list.document.split(',');
          this.documentIdx = documentIdx.map(Number);
        }
      });
    },
    // 刷新后重新获取当前页面的标签位置
    getRouterName(roterNmae) {
      let meanRoutes = this.labletable.map(item=>item.path);
      let active = meanRoutes.indexOf(roterNmae);
      this.defaultActive = String(active) === '-1' ? '' : String(active);
      let topMeanRoutes = this.photoList.map(item=>item.path);
      this.photoindex = topMeanRoutes.indexOf(roterNmae);
    },
    photoArea(index) {
      this.photoindex = index;
      this.defaultActive = '';
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    //点击首页返回首页
    personcenterhome(index, item) {
      this.lableindex = index;
      this.photoindex = -1;
    },
    studyset() {
      this.studycheck = [];
      this.studycheckzy = [];

      this.getPmiPickm();
      this.getPmiPic();

      this.dialogVisibleStudy = true;
    },
    passSet() {
      this.getListbaseType();
      this.getuseId();
    },
    //获取账户信息
    getuseId() {
      let useId = this.$store.state.User.ids;
      perapi.GetPmiUser({ id: useId }).then((res) => {
        // this.userIdData = res.result;
        this.userIdData = Object.assign({}, res.result);

        if(this.userIdData.birthday){
          let str = '' + this.userIdData.birthday
          this.userIdData.birthday = str.split(' ')[0];
        }
        // console.log(this.userIdData);

        if (this.userIdData.labelId && this.userIdData.labelId != 0) {
          this.labelIdList = this.userIdData.labelId.split(',');
          this.labelIdList = this.labelIdList.map(Number);
        }

        this.dialogVisiblepass = true;
      });
      perapi.PmiPwdSetget().then((res) => {
        this.rules.passWord[1].pattern = res.result.pwdRule.split('#')[0];
        this.rules.passWord[1].message = res.result.pwdRule.split('#')[1];
        this.isDept = res.result.isDept;
      });
    },

    // 修改账户信息
    UploadUser() {
          if (this.userIdData.deptId == 1) {
              this.$message.warning('部门不能选择新疆');
              return;
          }
      let _this = this;
      this.$refs['userIdData'].validate((valid) => {
        if (valid) {
          perapi.UploadPmiUser(this.userIdData).then((res) => {
            this.$message.success('成功！');
            // this.dialogVisiblepass = false;
            // _this.$router.push('/home');
            // _this.$store.commit('SET_TOKENS', '');
            // _this.$store.commit('SET_INFOS', '');
            // removeInfo('infos');
            // removeInfo('tokens');
            // removeInfo('IDS');
            // window.location.reload();
          });
        }
      });
    },
    chilUpload(val) {
      //  console.log(val)
      this.userIdData.photo = val;
    },
  },
};
</script>
<style scoped>
.header {
  background-color: #fff !important;
}
.heightlight {
  box-shadow: 2px 2px 10px rgba(179, 179, 179, 0.969) !important;
  border-radius: 5px;
}
.persbox {
  background-size: cover;
}
.personMessage {
  width: 1200px;
  padding: 30px 0;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.messageLeft {
  display: flex;
  align-items: center;
  padding-right: 25px;
  border-right: 1px solid #dedede;
}
.messageLeft > img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin: 0 20px;
  border: 3px solid #9dc3f2;
}
.messageflex {
}
.messageflex button {
  cursor: pointer;
  width: 90px;
  height: 25px;
  border-radius: 12px;
  background-color: #fff2cc;
  text-align: center;
  font-size: 14px;
  line-height: 25px;
  border: 0;
  display: block;
  margin-bottom: 10px;
}
.messageCenter {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #dedede;
  color: #fff;
  padding-left: 10px;
}
.messageCenter > div {
  width: 90px;
}
.messageCenter > div > .a > div > .item > img {
  width: 60px;
  height: 60px;
}
.messageCenter > div > .a > div > img {
  width: 60px;
  height: 60px;
}
.messageimg {
  width: 60px;
  height: 60px;
  margin: 0 auto;
}
.messageCenter > div > .a > div {
  text-align: center;
}
.messageRight {
  color: #fff;
  text-align: center;
  padding-left: 30px;
}
.messageRight > div {
}
.messageRight > div > div:nth-child(1) {
}
.messageRight > div > div:nth-child(2) > div {
  font-size: 18px;
  margin-top: 5px;
}
.messageRight > div > div > img {
  height: 40px;
  width: 40px;
  vertical-align: middle;
}
.messageRight > div > div > span {
  font-size: 24px;
  font-weight: bold;
  padding-left: 10px;
}
.persondata {
  width: 1200px;

  margin: 0 auto;
  margin-top: 20px;
  display: flex;
}
.persondataleft {
  width: 160px;
}
.persondataleft > div:nth-child(1) {
  width: 160px;
  box-shadow: 2px 2px 8px rgb(215 215 215 / 35%);
}
.persondataright {
  width: 1010px;
  background-color: #fff;
  border: 1px solid #f2f2f2;
  margin-bottom: 20px;
  min-height: 600px;
}

.el-menu-vertical-demo {
  border-radius: 5px;
  box-shadow: 2px 2px 5px rgb(215 215 215 / 35%);
  border-right: 0;
  min-height: 602px;
}
.el-menu-vertical-demo /deep/.el-menu-item{
  height: 45px;
  line-height: 45px;
}
/deep/.el-dialog__header {
  padding: 20px;
  padding-bottom: 10px;
}
.studynav {
  text-align: center;
  margin-bottom: 20px;
}
.studynav > div:nth-child(1) {
  font-weight: 700;
  font-size: 18px;
}
.passBox {
  width: 100%;
  /* height: 400px; */
  /* background-color: #ccc; */
}
.passboxtop {
  height: 60%;
  background-color: #fff;
}
.passboxbottom {
  /* height: 10%; */
}
.zymsg {
  display: flex;
  padding-bottom: 20px;
}
.zymsgtitle {
  font-size: 14px;
  font-weight: bold;
  width: 100px;
  display: block;
}

/deep/ .dialog-mini .el-dialog__footer {
  text-align: right;
}
</style>